import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import ServiceType from '../../../constants/ServiceType';

import {
	uploadAssetJson
} from '../../../api/api';

const override = css`
margin-top: -550px;
`;

class UploadAssetJsonModal extends Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);

    this.state = {
      file:'',
      loading: false
    };
  }

  onFileChange(e) {
    this.setState({
      file: e.target.files[0],
    });
  }


  uploadAssetJson = (event) => {
     let self = this;
     const formData = new FormData();
     if(self.state.file !== '')
     {
         formData.append('file',self.state.file);
     }

     formData.append('serviceTypeName', this.props.serviceTypeName);
     formData.append('assetVersionId', this.props.assetVersionId);
     formData.append('username', this.props.username);
     formData.append('serviceName', this.props.serviceName);
     formData.append('assetVersion', this.props.assetVersion);

     self.setState({
         loading: true,
     });
     uploadAssetJson(formData, (err, res) => {
         self.setState({
             loading: false,
         });
         if (err) {
            vex.dialog.alert('Failed to update json!');
          } else {
            vex.dialog.alert('Json Updated!');
          }
         
         self.props.hideModal();
     });
  }

  onShowModal = (evt) => {
	  let serviceTypeName=this.props.serviceTypeName;
	  let assetVersionId=this.props.assetVersionId;
	  let username= this.props.username;
	  let serviceName=this.props.serviceName;
	  let assetVersion=this.props.assetVersion;
  }

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            onEntered = {this.onShowModal}
            backdrop="static"
            style={{width:'100%'}}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Messgae</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <Form>
                 <FormGroup controlId="formControlsFile">
                      <ControlLabel>Attach Asset Json</ControlLabel>
                      <FormControl type="file" name="file" onChange={this.onFileChange}/>
                 </FormGroup>
             </Form>
             <ClipLoader
             className={override}
             sizeUnit={'px'}
             size={500}
             color={'#123abc'}
             loading={this.state.loading}>
             </ClipLoader>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.uploadAssetJson}>Save</Button>
            <Button onClick={this.props.hideModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

UploadAssetJsonModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired
};

export default UploadAssetJsonModal;



// WEBPACK FOOTER //
// ./src/routes/asset/components/UploadAssetJsonModal.js